<template>
    <section class="sub-section">
        <v-container>
            <div class="tab-wrap">
                <ul class="tab tab--block">
                    <li class="tab__li">
                        <button class="button tab__btn" v-bind:class="{ active: isActive }" @click="search('국내')">Domestic</button>
                    </li>
                    <li class="tab__li">
                        <button class="button tab__btn" v-bind:class="{ active: !isActive }" @click="search('해외')">Oversea</button>
                    </li>
                </ul>
            </div>

            <table class="board-list d-none d-lg-table">
                <thead class="d-none d-lg-table-header">
                    <tr>
                        <th style="width:30%;" class="board-list__txt"></th>
                        <th style="width:20%;" class="board-list__tit">Company</th>
                        <th style="width:50%;" class="board-list__txt">Details</th>
                    </tr>
                </thead>
            </table>
            <div class="partner-group">
                <div class="d-flex flex-column flex-lg-row align-start align-lg-stretch partner-wrap"  v-for="partner in partners" :key="partner._id">
                    <div>
                        <div class="partner-thum-wrap" style="cursor: pointer">
                            <img :src="partner.thumb" @click="open(partner.company.URL)" class="partner-thum">
                        </div>
                    </div>
                    <div class="parnter-info">{{ partner.company.name }}</div>
                    <div class="parnter-info ellip">{{ partner.company.about }}</div>
                </div>
            </div>

            <div class="v-pagination-wrap">
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </v-container>
    </section>
</template>

<script>
import api from "@/api"

export default {
    data() {
        return {
            boards: [],
            partners: [],

            filter: {
                language: "en",
                code: "partners",
                category: "국내"
            },
            page: 1,
            totalCount: 0,
            limit: 15,

            isActive: true
        }
    },
    async mounted(){
        await this.init()
    },
    computed: {
        pageCount() {
            return Math.ceil(this.totalCount / this.limit)
        },
        skip() {
            return (this.page - 1) * this.limit
        },
    },
    methods: {
        async init(){
            let { boards: partners, summary } = await api.v1.boards.gets({
                headers: { skip: this.skip, limit: this.limit },
                params: { ...this.filter }
            })
            this.totalCount = summary.totalCount
            this.partners = partners
        },
        async search(data){
            if(data == "해외"){
                this.isActive = false
            } else {
                this.isActive = true
            }
            this.filter.category = data
            await this.init()
        },
        open(URL){
            if(URL) window.open(URL)
            return;
        }
    },
    watch: {
        async page() {
            await this.init()
        },
    }
};
</script>


<style scoped>
    .container {
        padding: 0;
        padding-left: 15px;
        padding-right: 15px;
    }
    ul {
        display: flex;
    }

    ul li {
        position: relative;
        width: 50%;
    }

    .partner-group .partner-wrap:first-child{
        border-top: 2px solid var(--v-primary-base);
    }

    .partner-wrap{
        border-bottom: 1px solid #e2eaf6;
    }

    .partner-wrap>*{
        padding: 10px;
        width: 100%;
    }

    .partner-wrap>*:nth-child(2){
        padding-top: 10px;
        padding-bottom: 0;
    }

    .parnter-info{
        text-align: left;
        font-size: 1.4rem;
        color: #494949;
    }

    .partner-thum-wrap{
        position: relative;
        width: 100%;
        height: 0;
        padding-top: calc((150 / 360) * 100%);
    }

    .partner-thum{
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }

    @media (min-width:576px){
    }
    @media (min-width:768px){
    }
    @media (min-width:1024px){
        .partner-group .partner-wrap:first-child{
            border-top: 0;
        }

        .partner-wrap>*:nth-child(1){
            width: 30%;
        }

        .partner-wrap>*:nth-child(2){
            width: 20%;
            padding: 10px;
        }

        .partner-wrap>*:nth-child(3){
            width: 50%;
        }

        .parnter-info{
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            font-size: 1.8rem;
        }
    }
    @media (min-width:1200px){
    }

</style>